export { LightSocialLink } from './SocialLink';
export type { LightSocialLinkProps } from './SocialLink.types';
